let html = `<div class="search-box">
    <div class="search-box__input search__input"></div>
    <div class="search-box__keypad"><div class="simple-keyboard"></div></div>
</div>`

export default html